import { Link } from "react-router-dom";
import { parent_routes } from "../../../router/all_routes";
import { useAcademicYear } from "../../../../core/common/context/AcademicYearContext";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { getStudentClaims } from "../../../../api/claim";
import { useChildrenDetails } from "../../../../core/common/context/ChildrenDetailsContext";
import { ExtendHeaderPageComponent } from "../parentDashBoard";
import NoRegistratedAlert from "../noRegistratedAlert";
// import "./index.css"

const StudentClaimList = () => {
  const routes = parent_routes;

  const { childrenDetails, selectedChild, setSelectedChild } =
    useChildrenDetails();
  const [selectedChildInfos, setSelectedChildInfos] = useState<any>();

  const { selectedYear } = useAcademicYear();

  //Initialisation des state utilisés
  const [allClaims, setAllClaims] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Pour le vrai chargement
  const [hasLoaded, setHasLoaded] = useState(false); // Pour éviter "Chargement..." quand il n'y a juste pas de données

  const [refreshKey, setRefreshKey] = useState(0);

  // charger les informations detwilles de l'enfant selectionner
  useEffect(() => {
    const matchedChild = childrenDetails.find(
      (c: any) => c.id === selectedChild,
    );
    // console.log("Matched !: ", matchedChild);
    if (matchedChild) setSelectedChildInfos(matchedChild);
  }, [selectedChild, childrenDetails]);

  useEffect(() => {
    // On attend que selectedYear soit défini
    if (
      !selectedChildInfos?.id ||
      selectedChildInfos?.academicYear?.id !== selectedYear?.id
    )
      return;
    const fetchClaims = async () => {
      try {
        const response = await getStudentClaims(
          selectedYear?.id,
          selectedChildInfos?.id,
        );
        const claims = response?.data?.claims || [];

        setAllClaims(claims);

        console.log("Claims", response);
      } catch (error: any) {
        setAllClaims([]);
        console.log("erreur de chargement des Réclamations : ", error);
        toast.error(
          error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Une erreur s'est produit, Réessayer plus tard",
        );

        // Option: reset les salles en cas d'erreur
        setAllClaims([]);
      } finally {
        setIsLoading(false); //Les données ne sont plus en chargement
        setHasLoaded(true); //Les données ont été chargé avec succès
      }
    };

    fetchClaims();
  }, [selectedYear?.id, selectedChildInfos?.id, refreshKey]); // Recharger si l'année ou l'utilisateur change

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("fr-FR", {
      month: "short",
      year: "numeric",
    })
      .format(date)
      .replace(/^\w/, (c) => c.toUpperCase()); // Mettre la 1ère lettre en majuscule
  };

  type ReclamationStatus = "Envoyé" | "Traité" | "Annulé" | "Clôturé";

  type StatusConfig = {
    label: string;
    badgeClass: string;
    dotClass: string;
    leftBorderColor: string;
  };

  const STATUT_CONFIG: Record<ReclamationStatus, StatusConfig> = {
    Envoyé: {
      label: "En cours d'analyse",
      badgeClass: "badge-warning",
      dotClass: "text-warning",
      leftBorderColor: "#f59f00",
    },
    Traité: {
      label: "Acceptée",
      badgeClass: "badge-success",
      dotClass: "text-success",
      leftBorderColor: "#198754",
    },
    Annulé: {
      label: "Annulée",
      badgeClass: "badge-danger",
      dotClass: "text-danger",
      leftBorderColor: "#dc3545",
    },
    Clôturé: {
      label: "Clôturée",
      badgeClass: "badge-info",
      dotClass: "text-info",
      leftBorderColor: "#2459e9",
    },
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="mb-3">
              <div className="d-flex align-items-center justify-content-between flex-nowrap gap-2 mb-1">
                <h3 className="page-title mb-0 text-truncate">
                  Mes Réclamations
                </h3>
              </div>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    {" "}
                    <Link to={routes.parentDashboard}>Accueil</Link>
                  </li>
                  <li className="breadcrumb-item">
                    {selectedChildInfos?.class?.Level?.abbreviation}{" "}
                    {selectedChildInfos?.class?.label}
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Réclamations
                  </li>
                </ol>
              </nav>
            </div>
            <ExtendHeaderPageComponent
              childrenDetails={childrenDetails}
              activeStudent={selectedChild}
              setSelectedChild={setSelectedChild}
              handleClick={(selectedChild: any) =>
                setSelectedChild(selectedChild)
              }
            />
          </div>

          {/* /Page Header */}

          {isLoading ? (
            <div className="text-center py-5">
              <span className="spinner-border text-primary" />
            </div>
          ) : selectedChildInfos?.academicYear?.id !== selectedYear?.id ? (
            <NoRegistratedAlert />
          ) : !allClaims?.length ? (
            <div className="text-center py-5 text-muted">
              <i className="ti ti-inbox fs-1 d-block mb-2" />
              Aucune réclamation soumise pour le moment.
            </div>
          ) : (
            <div style={styles.container}>
              {allClaims.map((claim: any) => {
                const sc =
                  STATUT_CONFIG[claim.statut_claim as ReclamationStatus] ??
                  STATUT_CONFIG["Envoyé"];
                return (
                  <Link
                    key={claim.id}
                    to={routes.claimDetails.replace(":id", claim.id)}
                    style={styles.claimCardLink}
                  >
                    <div style={styles.claimCard}>
                      <div
                        style={{
                          ...styles.leftBorder,
                          backgroundColor: sc.leftBorderColor,
                        }}
                      ></div>

                      <div style={styles.claimContent}>
                        <div style={styles.headerRow}>
                          <h3 style={styles.subject}>
                            {claim.Note.SubjectUE.Subject.label}
                          </h3>
                          <span
                            className={`badge d-inline-flex align-items-center ${sc.badgeClass}`}
                            style={styles.statusBadge}
                          >
                            <i className={`ti ti-circle-filled fs-6 me-1`}></i>
                            {claim.statut_claim}
                          </span>
                        </div>
                        <p style={styles.details}>
                          {new Date(claim.createdAt).toLocaleDateString(
                            "fr-FR",
                            {
                              day: "2-digit",
                              month: "long",
                              year: "numeric",
                            },
                          )}{" "}
                          •{" "}
                        </p>
                        <p style={styles.room}>
                          Note: {claim.Note.value}/20 • Prof:{" "}
                          {claim.Note.SubjectUE.TeacherProfil.firstname}{" "}
                          {claim.Note.SubjectUE.TeacherProfil.lastname}
                        </p>
                      </div>

                      <div style={styles.arrow}>
                        <i className="ti ti-chevron-right me-2" />
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default StudentClaimList;

const styles = {
  claimCardLink: {
    textDecoration: "none",
    color: "inherit",
    display: "block",
  },
  arrow: {
    marginLeft: "auto",
    display: "flex",
    alignItems: "center",
    fontSize: 20,
    color: "#6c757d",
    flexShrink: 0,
  },
  container: {
    padding: "10px",
    backgroundColor: "#f5f6fa",
    minHeight: "100vh",
  },
  claimCard: {
    display: "flex",
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    marginBottom: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    overflow: "hidden",
  },
  leftBorder: {
    width: "6px",
    flexShrink: 0,
  },
  claimContent: {
    padding: "12px",
    flex: 1,
    minWidth: 0,
  },
  subject: {
    margin: "0 0 6px 0",
    fontSize: "16px",
    flex: 1,
    minWidth: 0,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    flexWrap: "nowrap" as const,
  },
  statusBadge: {
    flexShrink: 0,
  },
  details: {
    margin: "0",
    fontSize: "14px",
    color: "#555",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  room: {
    margin: "4px 0 0 0",
    fontSize: "14px",
    color: "#777",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
};
